module.exports = __webpack_public_path__ + "static/media/Electric_hum.642047a4.mp3";